export let CONSTANTS = {
  supportEmail: "colorpredictiontool@avient.com",
  rtCurveLength: 31
};

export let RESIN_CLASS = ['PO','PET'];

export let DEFAULT_RESIN_CLASS_PO = 'PO';

export let TOKEN_REFRESH_INTERVAL = 4 * 60 * 1000; // Minutes * Seconds * Miliseconds

export let RESIN_CLASS_SUB_CLASS_MAPPING = {
  'PE-HD': 'rHDPE',
  'PE-LD': 'rLDPE',
  'PP-C': 'rPP',
  'PP-H': 'rPP',
  'PP-R': 'rPP',
  'PET': 'rPET'
};

export const MAX_LAB_VALUES = 100;